module.exports = "/_next/static/images/3e185dc349233929cee668c6fff59cc7-two-people-looking-lg@1x.jpg.webp";